export default {
  list: {
    title: '通知一覧',
    messageTitle: '知らせ',
    viewAll: 'すべて表示',
    searchPlaceholder: 'メッセージ検索',
    markAllRead: 'すべて既読',
    settings: '通知設定',
    totalCount: '合計',
    unreadCount: '未読',
    unit: '件',
    onlyUnread: '未読のみ',
    columns: {
      type: 'タイプ',
      message: 'メッセージ詳細',
      time: 'メッセージ日時',
      operations: '操作'
    },
    operations: {
      markRead: '既読にする',
      markUnread: '未読にする',
      view: '既読に転送'
    }
  },
  tabs: {
    unread: '通知',
    all: '公告'
  },
  categories: {
    all: '全部',
    job: '求人',
    candidate: '選考'
  },
  status: {
    unread: '未読',
    read: '既読'
  },
  types: {
    // 職位関連
    jobPosted: '職位発布',
    jobOpened: '職位開放',
    jobClosed: '職位閉鎖',

    // 選考関連
    newApplication: '新規応募',
    selectionStageChanged: '選考状態変更',
    interviewScheduleSent: '面接日程送信済み',
    interviewScheduleAccepted: '面接日程受諾済み',
    interviewSchedulePending: '面接日程調整待ち',
    interviewScheduleAdjusted: '面接日程調整済み',
    interviewScheduleExpired: '面接日程期限切れ',
    interviewScheduleRescheduled: '面接日程再予約',
    joinDateConfirmed: '入社日確認',
    joined: '入社確認',
    selectionTerminated: '選考終了',
    internalMessage: '内部メッセージ',
    externalContact: '外部連絡'
  },
  messages: {
    markAllReadSuccess: 'すべて既読にしました',
    markReadSuccess: '既読にしました',
    markUnreadSuccess: '未読にしました',
    viewDetail: '詳細を表示'
  },
  announcementDialog: {
    confirm: '確認しました'
  },
  settings: {
    pageTitle: '通知設定',
    breadcrumb: {
      messageCenter: '通知一覧',
      messageSettings: '通知設定'
    },
    jobSection: '求人',
    candidateSection: '選考',
    selfReceive: '自分が受信するか',
    recipients: '受信対象',
    settingButton: '設定',
    onlySuperAdmin: 'この設定は管理者が一括で行います',
    defaultRecipients: '候補者担当、選考担当',
    externalRecipients: '選考担当',
    recipientsCount: '{count}個',
    updateSuccess: '設定を更新しました',
    updateFailed: '設定の更新に失敗しました',
    recipientUpdateSuccess: '受信対象を更新しました',
    recipientUpdateFailed: '受信対象の更新に失敗しました',
    loadFailed: '設定の読み込みに失敗しました'
  },
  recipientDialog: {
    title: '受信対象設定',
    subtitle: 'テンプレート「{title}」の受信対象を選択してください。',
    searchPlaceholder: '役割/アカウントタイプ/アカウント名で検索',
    defaultSend: 'デフォルトで送信',
    roles: 'タイプ',
    accounts: 'アカウント',
    selected: '選択済み',
    candidateOwner: '候補者担当',
    selectionOwner: '選考担当'
  },
  // メッセージテンプレート
  messageTemplates: {
    // 企業端テンプレート
    jobPublish: '「[[userName]]」さんが新規求人「[[jobTitle]]」を公開しました。',
    jobOpen: '求人「[[jobTitle]]」が以下の人材紹介会社に公開されました：[[headhunterCompanyNames]]',
    jobClose: '「[[userName]]」さんが 「[[jobTitle]]」をクローズしました。',
    newApplication: '求人「[[jobTitle]]」への新規エントリーがありました。',
    selectionStatusChange: '候補者「[[candidateName]]」さんの選考が「[[stepName]]」に進みました。',

    selectionTerminate: '候補者「[[candidateName]]」さんの選考が「[[stepName]]」にて中止しました，',
    confirmJoinDate: '候補者「[[candidateName]]」さんの入社日が「[[joinDate]]」に確定しました。',
    confirmJoin: '候補者「[[candidateName]]」さんの入社が確定しました。',
    

    interviewScheduleSent: '候補者「[[candidateName]]」さんの「[[stepName]]」候補日を送信しました。日程確認待ち。',
    interviewScheduleAccepted: '候補者「[[candidateName]]」さんの「[[stepName]]」日程が 「[[interviewTime]]」に確定しました。',
    interviewSchedulePending: '候補者「[[candidateName]]」さんより「[[stepName]] 日程の変更希望が届きました。',
    interviewScheduleExpired: '候補者「[[candidateName]]」さんの「[[stepName]]」候補日程が期限切れとなり、再調整が必要です。',
    interviewScheduleAdjusted: '候補者「[[candidateName]]」さんの「[[stepName]]」日程が再調整されました。',
    
    interviewScheduleRescheduled: '候補者「[[candidateName]]」さんの「[[stepName]]」日程が再調整され、日程確認待ち。',
   
    internalComment: '「[[userName]]」さんが候補者「[[candidateName]]」の「社内連絡」にメッセージを送信しました。（[[remarkContent]]）',
    externalContact: '「[[userName]]」さんが候補者「[[candidateName]]」の「社外連絡」にメッセージを送信しました。（[[remarkContent]]）',
    // 人材紹介会社端テンプレート（productId === 3）
    agent: {
      jobPublish: '「[[userName]]」 の求人「[[jobTitle]]」が貴社に公開されました。',
      jobOpen: '[[enterpriseName]] の求人「[[jobTitle]]」が貴社に公開されました。',
      jobClose: '[[enterpriseName]] が 「[[jobTitle]]」をクローズしました。',
      newApplication: '求人「[[jobTitle]]」への新規エントリーがありました。',
      selectionStatusChange: '候補者「[[candidateName]]」さんの選考が「[[stepName]]」に進みました。',
      selectionTerminate: '候補者「[[candidateName]]」さんの選考が「[[stepName]]」にて中止しました，',
      confirmJoinDate: '候補者「[[candidateName]]」さんの入社日が「[[joinDate]]」に確定しました。',
      confirmJoin: '候補者「[[candidateName]]」さんの入社が確定しました。',
      interviewScheduleSent: '候補者「[[candidateName]]」さんの「[[stepName]]」候補日を送信しました。日程確認待ち。',
      interviewScheduleAccepted: '候補者「[[candidateName]]」さんの「[[stepName]]」日程が 「[[interviewTime]]」に確定しました。',
      interviewSchedulePending: '候補者「[[candidateName]]」さんより「[[stepName]] 日程の変更希望が届きました。',
      interviewScheduleExpired: '候補者「[[candidateName]]」さんの「[[stepName]]」候補日程が期限切れとなり、再調整が必要です。',
      interviewScheduleAdjusted: '候補者「[[candidateName]]」さんの「[[stepName]]」日程が再調整されました。',
      interviewScheduleRescheduled: '候補者「[[candidateName]]」さんの「[[stepName]]」日程が再調整され、日程確認待ち。',
      internalComment: '「[[userName]]」さんが候補者「[[candidateName]]」の「社内連絡」にメッセージを送信しました。（[[remarkContent]]）',
      externalContact: '「[[userName]]」さんが候補者「[[candidateName]]」の「社外連絡」にメッセージを送信しました。（[[remarkContent]]）',
    },
    // 固定文言
    candidateSource: '候補者チャンネル：',
    enterpriseName: '採用企業：',
    requestAdjustTime: '',
    remark: '',
    adjusted: '',
    expired: '',
    awaitingReschedule: '',
    rescheduled: '',
    awaitingConfirm: '',
    confirmedJoin: '',
    terminateStage: '',
    terminateReason: '中止理由：',
    terminated: '',
    stage: ''
  }

};
